<script setup lang="ts">
import {useI18n} from "vue-i18n";

const {t} = useI18n()
</script>


<template>
  <div class="mobile-subsidebar">
    <div class="inner">
      <div class="sidebar-title">
        <h3>{{t('sidebar-user')}}</h3>
      </div>

      <ul class="submenu" data-simplebar>
        <li>
          <RouterLink :to="{ name: 'users-list' }">
            {{ t('sidebar-user-list') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'users-group-list' }">
            {{ t('sidebar-roadshow-user-group') }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/abstracts/_variables.scss';
@import '../../scss/layout/_sidebar-mobile.scss';
</style>
